import React, { useEffect, useRef } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Filmography from '../components/Filmography'; // <-- ON IMPORTE FILMOGRAPHY
import Skills from '../components/Skills';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { animateNumbers } from '../utils/animations';

const Home = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    // Animate numbers on load
    animateNumbers();

    const sections = sectionsRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="home">
      <Header />
      <main>
        <section ref={(el) => (sectionsRef.current[0] = el)} className="fade-in-section">
          <Hero />
        </section>
        <section ref={(el) => (sectionsRef.current[1] = el)} className="fade-in-section">
          <About />
        </section>
        <section ref={(el) => (sectionsRef.current[2] = el)} className="fade-in-section">
          <Filmography /> {/* NE METS QUE FILMOGRAPHY ICI, PAS PROJECTS */}
        </section>
        <section ref={(el) => (sectionsRef.current[3] = el)} className="fade-in-section">
          <Skills />
        </section>
        <section ref={(el) => (sectionsRef.current[4] = el)} className="fade-in-section">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;